// ** Third Party Components
import { useCallback, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ArrowLeft, ArrowRight, Plus, XCircle } from 'react-feather';

// ** Reactstrap Imports
import {
  Label,
  Row,
  Col,
  Button,
  Input,
  ListGroup,
  ListGroupItem,
  Form
} from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const _data = new Map();

const FrasesCreator = ({
  stepper,
  handleOnSubmit,
  defaultValues,
  editMode = false
}) => {
  const [frases, setFrases] = useState(defaultValues.frases || []);
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit
  } = useForm({
    defaultValues: {
      frase: ''
    }
  });

  const handleSave = useCallback(
    (newData) => {
      _data.clear();
      newData.forEach((q, idx) => {
        _data.set(`${idx}`, q);
      });
      setFrases(newData);
      setValue('frase', '');
    },
    [_data]
  );

  const handleDelete = (id) => {
    _data.delete(id);
    const val = [..._data.values()];
    handleSave(val);
  };

  const onSubmit = (item) => {
    handleSave([..._data.values(), item.frase]);
  };

  const _onSubmit = (e) => {
    e.preventDefault();

    handleOnSubmit(
      {
        frases: [..._data.values()].map((item) => item)
      },
      true
    );

    return MySwal.fire({
      title: editMode ? 'Episodio actualizado!' : 'Episodio creado!',
      text: editMode
        ? 'Episodio actualizado con exito!'
        : 'El episodio fue creado con exito!',
      icon: 'success',
      customClass: {
        confirmButton: 'btn btn-primary'
      },
      buttonsStyling: false
    });
  };

  useEffect(() => {
    handleSave(defaultValues.frases || []);
  }, [handleSave]);

  return (
    <>
      <div className="content-header">
        <h5 className="mb-0">Crear Frases</h5>
        <small className="text-muted">
          Crear Frases para compartir de esta leccion.
        </small>
      </div>
      <Row className="mb-5">
        <Col md="6">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Label className="form-label" for="video">
              Escribe una frase
            </Label>
            <Row>
              <Col md="11">
                <Controller
                  id="frase"
                  name="frase"
                  control={control}
                  rules={{ maxLength: 140 }}
                  render={({ field }) => (
                    <Input
                      type="textarea"
                      placeholder="Maximo 140 caracteres"
                      required
                      invalid={errors.frase}
                      {...field}
                    />
                  )}
                />
              </Col>
              <Col md="1">
                <Button
                  type="submit"
                  color="#7367F0"
                  style={{
                    background: '#7367F0',
                    padding: 10
                  }}
                >
                  <Plus
                    color="white"
                    size={15}
                    enableBackground="#7367F0"
                    fill="#7367F0"
                  />
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col md="6">
          <ListGroup>
            {frases.map((item, idx) => (
              <ListGroupItem
                key={`idx_${idx}`}
                className="d-flex justify-content-between align-items-center"
              >
                <span>{item}</span>
                <Button
                  type="submit"
                  color="#7367F0"
                  style={{
                    background: '#7367F0',
                    padding: 10
                  }}
                  onClick={() => handleDelete(`${idx}`)}
                >
                  <XCircle
                    enableBackground="#7367F0"
                    fill="#7367F0"
                    color="white"
                    style={{
                      cursor: 'pointer'
                    }}
                  />
                </Button>
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
      </Row>
      <form onSubmit={_onSubmit}>
        <div className="d-flex justify-content-between">
          <Button
            type="button"
            color="secondary"
            className="btn-prev"
            outline
            onClick={() => {
              stepper.previous();
            }}
          >
            <ArrowLeft size={14} className="align-middle me-sm-25 me-0" />{' '}
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </Button>
          <Button type="submit" color="primary" className="btn-next">
            <span className="align-middle d-sm-inline-block d-none">
              {editMode ? 'Actualizar' : 'Crear'}
            </span>
            <ArrowRight size={14} className="align-middle ms-sm-25 ms-0" />
          </Button>
        </div>
      </form>
    </>
  );
};

export default FrasesCreator;
